import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../Context/PageContext";
import EditImg from "./img/border_color_black.png"
import DeleteImg from "./img/delete_foreve.png"
import NumberIcon from "./img/pin.png"
import LoginIcon from "./img/account_box.png"
import GenderIcon from "./img/wc.png"
import LoginCountIcon from "./img/sort.png"
import ActionIcon from "./img/more_vert.png"
import CharAmountIcon from "./img/groups.png"
import UltimoLogIcon from "./img/history.png"
import VipStarIcon from "./img/star.png"
import JobName from "./acessos/JobName";
import GoldStar from "./img/goldstar.png"
import ArrowLeft from "./img/keyboard_arrow_left.png"
import ArrowRight from "./img/keyboard_arrow_right.png"
import { ApiConnectUserAccessList, ApiConnectUserCharList } from "../../../api/ServerApiConect";
import PopMenuWindow, { OpenPopMenu } from "../../../PopMenuWindow/PopMenuWindow";
import CriarNovoAcesso from "./acessos/RegisterNewAccess";
import DeleteRegister from "./acessos/DeleteRegister";
import ChangeAccessPassword from "./acessos/ChangeAccessPassword";
import NotAuthorizedDeleteOperation from "./acessos/NotAuthorizedDeleteOperation";
import UserNotLogged from "./UserNotLogged";
import CharacterListContainer from "./acessos/CharacterListContainer";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../../Tooltip/Tooltip";
import { MobTipMouseOutEvent, MobTipMouseOverEvent } from "../../Database/MobShowToolTip";
import AcessosIcon from "./img/JobIcon.png"



function Acessos() {

    const className = JobName();

    const {setToolTipContent} = useContext(PageContext)

    var charCarrouselOpen = false;
    
    const { user, userCharacters, setUserCharacters, setPopMenuContent, managedAccess, setManagedAcess, userAccessList, setUserAccessList, setPage, setIsLogged } = useContext(PageContext);

    var AccessList = userAccessList;

    useEffect(() => {

        let resultPromise = ApiConnectUserAccessList(user);
        resultPromise.then((response) => {

            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged />);
                setIsLogged(false);
                return;
                }

            setTimeout(() => {  document.getElementById("MasterAcessoContainer").style.opacity = 1;

            if(response.data === false) { 
                setUserAccessList([])
                setUserCharacters([])
                return;

            }
            setUserAccessList(response.data);

            let resultCharList = ApiConnectUserCharList(response.data);
            resultCharList.then((response2) => setUserCharacters(response2));
        });

    }, 200)
            },[])


    function colapsideCharCarrousel(id){

        let carrousselChar = document.getElementById(id);

        if(charCarrouselOpen === false) {
            carrousselChar.style.height = "400px";
            charCarrouselOpen = true;
        } else {
            carrousselChar.style.height = "0px";
            charCarrouselOpen = false;
        }

    }

    function scrollCharacterListLeft (event){

        let carroussel = event.target.nextElementSibling;



        let carrouselMarginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0])

        if (carrouselMarginLeft === 0) { return ;}

        if(carrouselMarginLeft < (-240)){
            carroussel.style.marginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]) + 240 + "px";
            return;
        } 
        
        if(carrouselMarginLeft > -240 && carrouselMarginLeft < 0){
            carroussel.style.marginLeft = "0px";
        }


    }

    function scrollCharacterListRight (event) {

        let carroussel = event.target.previousElementSibling;
        let carrousselFather = carroussel.offsetParent;
        let carrouselSize = carroussel.children.length * 240;

        let boundary = carrouselSize - carrousselFather.getBoundingClientRect().width;
        let carrouselMarginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]);
        let avaliableDisplacement = boundary + carrouselMarginLeft; 

        if(boundary <= 0){ return }

        if (avaliableDisplacement >= 240 ){ 
            carroussel.style.marginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]) - 240 + "px";
            return;
        } else {

            carroussel.style.marginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]) - avaliableDisplacement + "px";
        }


    }

    return(
        <MasterAcessoContainer id="MasterAcessoContainer">

            <TitleMaster>
                <ColumItemHeaderIcon iconImg={AcessosIcon}/>
                <TitleFont>Contas de acesso ao servidor </TitleFont>
            </TitleMaster>

            <AcessMasterItemContainer>
            {
            AccessList.map((item) => {

                var character_slots = userCharacters.filter(char => char.account_id == item.account_id).length

                var VIPActive = "";
                var amountOfDays ="";

                if(item.group_id < 1) { VIPActive = " - " ; amountOfDays = "" } 
                else { VIPActive = <VipStarIconGold icon={GoldStar}/>; amountOfDays = item.vip_time + " Dias"}
                var AcessoItem =  <AcessoContainer
                                    onClick={() => colapsideCharCarrousel(item.account_id)}

                                    onMouseOver={(event) => {
                                        
                                        setToolTipContent(
                                         <AcessoCabecalho>
                                            <AcessoCabecalhoItem>
                                                <CabecalhoIcon img={GenderIcon}/>
                                                <AcessoCabecalhoSpan>Gênero da conta:</AcessoCabecalhoSpan>
                                                <AcessoCabecalhoProperty>{item.sex}</AcessoCabecalhoProperty>
                                            </AcessoCabecalhoItem>
                                            <AcessoCabecalhoItem>
                                                <CabecalhoIcon img={LoginCountIcon}/>
                                                <AcessoCabecalhoSpan>Qtd de Logins:</AcessoCabecalhoSpan>
                                                <AcessoCabecalhoProperty>{item.logincount}</AcessoCabecalhoProperty>
                                            </AcessoCabecalhoItem>
                                            <AcessoCabecalhoItem>
                                                <CabecalhoIcon img={UltimoLogIcon}/>
                                                <AcessoCabecalhoSpan>Ultima vez:</AcessoCabecalhoSpan>
                                                <AcessoCabecalhoProperty>{item.lastlogin}</AcessoCabecalhoProperty>
                                            </AcessoCabecalhoItem>
                                            <AcessoCabecalhoItem>
                                                <CabecalhoIcon img={CharAmountIcon}/>
                                                <AcessoCabecalhoSpan>Personagens: </AcessoCabecalhoSpan>
                                                <AcessoCabecalhoProperty>{character_slots}</AcessoCabecalhoProperty>                                               
                                            </AcessoCabecalhoItem>
                                            <AcessoCabecalhoItem>
                                                <CabecalhoIcon img={VipStarIcon}/>
                                                <AcessoCabecalhoSpan>VIP Ativo: </AcessoCabecalhoSpan>
                                                <AcessoCabecalhoProperty>{VIPActive} {amountOfDays}</AcessoCabecalhoProperty>
                                            </AcessoCabecalhoItem>
                                        </AcessoCabecalho>)

                                        MobTipMouseOverEvent(event, `Relatório de acesso`, "rgba(0,0,0,1)")
                                    }}
                                    
                                    onMouseLeave={() => MobTipMouseOutEvent()}>
                                    <AcessContainerA>
                                        <AcessoItemContainer>{VIPActive}</AcessoItemContainer>
                                        <AcessoItemContainer>{item.userid}</AcessoItemContainer>
                                    </AcessContainerA>

                                    <AcessContainerB>
                                        <AcessoItemContainer>
                                            <Edit 
                                                onClick={() => {
                                                    OpenPopMenu();
                                                    setManagedAcess(item)
                                                    setPopMenuContent(<ChangeAccessPassword/>)
                                                }}

                                                onMouseOver={(event) => {
                                                setToolTipContent(<></>)
                                                MobTipMouseOverEvent(event, `Editar Dados de Acesso`, "rgba(0,0,0,1)")}}
            
                                                onMouseLeave={() => MobTipMouseOutEvent()}
                                                />
                                            <Delete 
                                                onClick={() => {
                                                    if(item.vip_time > 0) {
                                                        OpenPopMenu();
                                                        setPopMenuContent(<NotAuthorizedDeleteOperation/>);
                                                        return;
                                                    }
                                                    OpenPopMenu();
                                                    setManagedAcess(item)
                                                    setPopMenuContent(<DeleteRegister/>)
                                                }}
                                            />

                                        </AcessoItemContainer>
                                    </AcessContainerB>

                             </AcessoContainer>;   
                           return <>
                                {AcessoItem}
                                <CharacterCarrousel id={item.account_id}>
                                    <LeftArrow icon={ArrowLeft} onClick={(e) => scrollCharacterListLeft(e)}/>
                                     <CharacterListContainer userCharacters={userCharacters} itemAccount={item}/>
                                    <RightArrow icon={ArrowRight} onClick={(e) => scrollCharacterListRight(e)}/>
                                </CharacterCarrousel>
                            </>;
              })}

            </AcessMasterItemContainer>

            <AcessoContainerNewAccount>
                <AcessoItemContainerNewAccount onClick={() => {
                    OpenPopMenu();
                    window.scrollTo(0, 100);
                    if(userAccessList.length < 5) {
                        setPopMenuContent(<CriarNovoAcesso />)
                    } else {
                        setPopMenuContent(<NotAllowedMoreAccounts>
                            Você atingiu o máximo de<br/>Acessos permitidos no momento.
                        </NotAllowedMoreAccounts>)
                    }
                    }}
                    >Novo Acesso +</AcessoItemContainerNewAccount>
            </AcessoContainerNewAccount>
            
        </MasterAcessoContainer>
    
    );
}

export default Acessos;


const MasterAcessoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    //border: solid 2px black;
    width: 860px;
    opacity: 0;
    transition: .7s ease-in-out;
    //box-shadow: 0px 0px 10px 0px black;
    margin: 30px 0 200px 0;
    padding: 10px;
    border-radius: 5px;

`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 30px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const AcessMasterItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: rgba(0,0,0,.7);
    border-radius: 10px;
    padding: 10px 0;

    @media(max-width: 1000px) {
      width: 90vw;
    }

`

const AcessoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    border-radius: 5px;
    margin: 5px 10px;
    transition: .3s ease-in-out;
    

    &:hover {
        transform: translate(0px, 0px);
        background-color: rgba(65, 102, 137, 0.8);
        color: white;

    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`
const AcessContainerA = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //background-color: rgba(212, 116, 116, 0.7);
    color: white;
    border-radius: 5px;
    transition: .3s ease-in-out;

`
const AcessContainerB = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    //background-color: rgba(130, 63, 63, 0.7);
    color: white;
    border-radius: 5px;
    transition: .3s ease-in-out;
    margin-right: 10px;

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;

    @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
`

const AcessoCabecalho = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    width: 100%;
    border-radius: 5px;
    //border: 1px solid black;
    background-color: rgba(0,0,0,.8);
    padding: 10px 5px;
    margin-bottom: 5px;

`

const AcessoCabecalhoItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid 2px black;
    width: 350px;
    padding: 5px;
    text-align: center;
    font-size: 12pt;
    background-color: rgba(179, 176, 176, 0.2);
    color: white;
    margin: 2px 0px;

    @media(Max-width: 1280px) {
        width: 110px;
    }

`

const AcessoCabecalhoSpan = styled.span`
    display: flex;
    justify-content: start;
    width: 140px;
`

const AcessoCabecalhoProperty = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    font-size: 12pt;
`

const CabecalhoIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    width: 25px;
    height: 25px; 
    background-blend-mode: multiply;
    margin-right: 10px;
`


const AcessoItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid 2px black;
    font-size: 14pt;
    height: 50px;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const Edit = styled.div`
    background-image: url(${EditImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    border: 1px solid;
    background-color: rgba(255, 255, 255, 0.9);
    //padding: 5px;
    width: 25px;
    height: 25px;
    margin-right: 10px;
    z-index: 3;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.2;
    }

`
const Delete = styled.div`
    background-image: url(${DeleteImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    border: 1px solid;
    background-color: rgba(255, 255, 255, 0.9);
    width: 25px;
    height: 25px;
    z-index: 3;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    transition: .3s ease-in-out;

    &:hover {
    scale: 1.5;
    }
`

const AcessoContainerNewAccount = styled.div`
    display: flex;
    align-items: center;
    color: white;
    width: 100%;
    height: 50px;
    margin: 20px 0;

    @media(max-width: 1000px) {
      width: 90vw;
    }
    
`

const AcessoItemContainerNewAccount = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid 2px black;
    width: 130px;
    height: 50px;
    opacity: .8;
    text-align: center;
    border-radius: 10px;
    background-color: rgb(26, 144, 67);
    font-size: 12pt;
    font-weight: bold;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    }
`

const KafraChibi = styled.div`
    background-image: url(${props => props.img});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100px;
    height: 75px;
`

const BannerContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //border: solid 2px black;
    border-radius: 10px;

    @media(max-width: 1000px) {
    width: 90vw;
    text-align: justify;
    margin-bottom: 20px;
    //border: solid 1px rgba(0,0,0, 1);
    }
`

const TitleContainer = styled.h1`
    display: flex;
    flex-direction: column;
    //border: solid 2px black;
    padding: 0;
    margin-left: 30px;
    
`;

const Span = styled.span`
    font-size: 18px;
    font-weight: normal;
    //border: solid 2px black;
     padding: 0;
     text-align: center;
     margin: 10px;

     @media(max-width: 1000px) {
    width: 100%;
    text-align: justify;
    margin: 0px;
    }
`;

const Title = styled.h3`
    text-align: center;
    //border: solid 2px black;
    padding: 0;
    margin: 0px 0;
`;


const CharacterCarrousel = styled.div`
    //border: solid 1px black;
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 100%;
    position: relative;
    height: 0px;
    border-radius: 10px;
    //border: solid 1px blue;
    transition: .3s ease-in-out;
    position: relative;
    background-color: rgba(0, 0, 0, .2);
`

const LeftArrow = styled.div`
    width: 50px;
    height: 50px;
    top: 0px;
    left: 0%;
    background-image: url(${props => props.icon});
    background-size: cover;
    backrgound-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    z-index: 2;
    opacity: .5;
    transition: .3s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    scale: 1.2;
    }
`

const RightArrow = styled.div`
    width: 50px;
    height: 50px;
    top: 0px;
    right: 0%;
    background-image: url(${props => props.icon});
    background-size: cover;
    backrgound-repeat: no-repeat;
    background-position: center center;

    position: absolute;
    z-index: 2;
    opacity: .5;
    transition: .3s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    scale: 1.4;
    }
`

const VipStarIconGold = styled.div`
    background-image: url(${props => props.icon});
    background-size: cover;
    backrgound-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
    margin: 0 20px;
`

const NotAllowedMoreAccounts = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 50px;
    background-color: white;
    border-radius: 10px;
    font-size: 30px;

`